import { render } from "./back.vue?vue&type=template&id=e7e7727a&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import "./back.vue?vue&type=style&index=0&id=e7e7727a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebastian\\Documents\\choferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e7727a"]])

export default __exports__